import styled from '@emotion/styled';
import React from 'react';
import { RadioV2 } from '@/components/@IntranetLibrary/Radio/RadioV2';

type P = {
  name: string;
  value: string;
  title: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

// 행 전체가 클릭 영역이라 v2rd-hover-target 부여 — 라벨 위에서도 hover 표시.
const RadioButton = ({ value, title, name, checked, onChange }: P) => {
  const id = `radio-${value}`;
  return (
    <Row className="v2rd-hover-target">
      <RadioV2
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        sx={{ padding: 0 }}
      />
      <StyledLabel htmlFor={id}>{title}</StyledLabel>
    </Row>
  );
};

export default RadioButton;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledLabel = styled.label`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  cursor: pointer;
`;
